import store from "../../configureStore";
import { RENDER_MESSAGE_TYPE_MAP } from "../../constants";
import { handleActionBasedTabUpdate, updateTabDataWithoutAction } from "./message-type-table";


export const handleMessageTypeMap = (conversationId, message) => (dispatch) => {
    const tabStack = store.getState().tabStack || {};
    const existingTabs = tabStack[conversationId] || {};
    const shouldUpdateSelectedTab = !message?.options?.updateInBackground;

    const updatedComponents = message?.options?.action
        ? handleActionBasedTabUpdate(existingTabs, message)
        : updateTabDataWithoutAction(existingTabs, message, dispatch);

    const updatedTabState = {
        ...updatedComponents,
        ...(shouldUpdateSelectedTab && { selectedTab: message?.options?.tabId }),
    };

    dispatch({
        type: RENDER_MESSAGE_TYPE_MAP,
        data: { [conversationId]: updatedTabState },
    });
};
